import {ApplicationConfig, provideZonelessChangeDetection} from '@angular/core';
import {NgHttpCachingConfig, NgHttpCachingStrategy, provideNgHttpCaching} from 'ng-http-caching';
import {provideRouter, TitleStrategy} from '@angular/router';
import {routes} from 'src/app/app-routes';
import {provideStore, withNgxsNoopExecutionStrategy} from '@ngxs/store';
import {SessionState} from 'src/app/shared/state/session-state';
import {environment} from 'src/environments/environment';
import {withNgxsStoragePlugin} from '@ngxs/storage-plugin';
import {provideNgxWebstorage, withLocalStorage, withSessionStorage} from 'ngx-webstorage';
import {PROJECT_CONFIG, ProjectConfig} from 'src/app/project.config';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {authJwtInterceptor} from 'src/app/core/interceptor/auth-jwt.interceptor';
import {logoutOnUnauthInterceptor} from 'src/app/core/interceptor/logout-on-unauth.interceptor';
import {serverErrorInterceptor} from 'src/app/core/interceptor/server-error.interceptor';
import {loadIndicatorInterceptor} from '@ratespecial/core';
import {provideCharts, withDefaultRegisterables} from 'ng2-charts';
import {AppTitleStrategy} from 'src/app/shared/page/app-title.strategy';

const ngHttpCachingConfig: NgHttpCachingConfig = {
  cacheStrategy: NgHttpCachingStrategy.DISALLOW_ALL, // must explicitly say something is cacheable
  lifetime: 600000, // 600,000 = 10 minutes
};

export const appConfig: ApplicationConfig =  {
  providers: [
    provideNgHttpCaching(ngHttpCachingConfig),
    provideCharts(withDefaultRegisterables()),
    provideRouter(routes),
    {
      provide: TitleStrategy,
      useClass: AppTitleStrategy,
    },
    provideStore([SessionState], {
      developmentMode: !environment.production,
    }),
    // The app runs without Zone, so NGXS has no zone to run its observables back inside of.
    withNgxsNoopExecutionStrategy(),
    withNgxsStoragePlugin({
      keys: ['session.token', 'session.isWidescreen'],
    }),
    provideNgxWebstorage(withLocalStorage(), withSessionStorage()),
    {
      provide: PROJECT_CONFIG,
      useValue: ProjectConfig,
    },
    provideHttpClient(
      withInterceptors([
        loadIndicatorInterceptor,
        authJwtInterceptor,
        logoutOnUnauthInterceptor,
        serverErrorInterceptor,
      ]),
    ),
    provideZonelessChangeDetection(),
  ],
};
